import SalesSuccessFilter from "../../Components/Filters/SalesSuccessFilter";
import { CardDetails } from "./SalesSuccessStatics/CardDetails";

import CoveragePlan from "./SalesSuccessStatics/CoveragePlan";
import TqpInsights from "./SalesSuccessStatics/TqpInsights";
import BTLChart from "./SalesSuccessStatics/Btl";
import LeadSourceCombined from "./SalesSuccessStatics/LeadSourceCombined";
import DseLowPipeline from "./SalesSuccessStatics/DseLowPipeline";
import Anlaytics from "./SalesSuccessStatics/Analytics";
import Salience from "./SalesSuccessStatics/Salience";
const SalesSuccess = () => {
  return (
    <div className=" w-full">
      <div className="px-2 mt-1">
        <SalesSuccessFilter />
      </div>
      <div className="w-full p-2">
        <section className="">
          <CardDetails />
        </section>
        <div className=" md:flex block mt-2 gap-2 w-full">
          <div className="md:w-[80%] w-full">
            <LeadSourceCombined />
          </div>
          <section className="md:w-[20%] w-full  md:mt-0">
            <Anlaytics />
          </section>
        </div>
        <section className="mt-2 md:flex block gap-2 w-full">
          <div className="md:w-[45%]  md:flex block w-full gap-2">
            <div className="w-full mt-2 md:mt-0">
              <BTLChart />
            </div>
            <div className="w-full mt-2 md:mt-0">
              <CoveragePlan />
            </div>
          </div>
          <div className="md:w-[55%]  md:flex block w-full gap-2">
            <div className="w-full mt-2 md:mt-0">
              <DseLowPipeline />
            </div>
            <div className="w-full mt-2 md:mt-0">
              <TqpInsights />
            </div>
          </div>
        </section>
        <section className="mt-2 md:flex block gap-2 w-full">
          <Salience />
        </section>
      </div>
    </div>
  );
};

export default SalesSuccess;
